module.exports = __webpack_public_path__ + "static/media/Logo NgoJak (1).4756c0b7.png";